var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22.75H7.5C4.2 22.75 3.75 20.95 3.75 19V10.22C3.75 9.80997 4.09 9.46997 4.5 9.46997C4.91 9.46997 5.25 9.80997 5.25 10.22V19C5.25 20.74 5.55 21.25 7.5 21.25H16.5C18.45 21.25 18.75 20.74 18.75 19V10.22C18.75 9.80997 19.09 9.46997 19.5 9.46997C19.91 9.46997 20.25 9.80997 20.25 10.22V19C20.25 20.95 19.8 22.75 16.5 22.75Z",
    fill: "#0b8369"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.75H5C2.58 10.75 1.25 9.42 1.25 7V5C1.25 2.58 2.58 1.25 5 1.25H19C21.42 1.25 22.75 2.58 22.75 5V7C22.75 9.42 21.42 10.75 19 10.75ZM5 2.75C3.42 2.75 2.75 3.42 2.75 5V7C2.75 8.58 3.42 9.25 5 9.25H19C20.58 9.25 21.25 8.58 21.25 7V5C21.25 3.42 20.58 2.75 19 2.75H5Z",
    fill: "#0b8369"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8199 14.75H10.1799C9.76993 14.75 9.42993 14.41 9.42993 14C9.42993 13.59 9.76993 13.25 10.1799 13.25H13.8199C14.2299 13.25 14.5699 13.59 14.5699 14C14.5699 14.41 14.2299 14.75 13.8199 14.75Z",
    fill: "#0b8369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.687e8621cfaa6f73390e474b4cb55f5c.svg";
export { ForwardRef as ReactComponent };